import { getBuyerId } from 'dibs-cookie-jar';
import { fetchQuery_DEPRECATED as fetchQuery, graphql, Environment } from 'react-relay/legacy';

import { vipCuratedFolderRule_Query as QueryType } from './__generated__/vipCuratedFolderRule_Query.graphql';

const query = graphql`
    query vipCuratedFolderRule_Query($userId: String!) {
        viewer {
            isDisabled: isEnabled(key: "disableCuratedFolders")
            user(userId: $userId) {
                activityFeed(first: 1, elementTypes: [VIP_CURATED_PORTFOLIO_SHARE]) {
                    edges {
                        node {
                            status
                        }
                    }
                }
            }
        }
    }
`;

export async function vipCuratedFolderRule({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> {
    const userId = getBuyerId(document.cookie);

    if (!userId) {
        return false;
    }

    const res = await fetchQuery<QueryType>(relayEnvironment, query, { userId });
    const hasUnread = res?.viewer?.user?.activityFeed?.edges?.[0]?.node?.status === 'ACTIVE';
    const isDisabled = res?.viewer?.isDisabled;
    return hasUnread && !isDisabled;
}
